/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} Audio_Description_Export_Status_Rendering_BatchInputs */

const en_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering Event Audio (${i?.start}-${i?.end} of ${i?.total})`)
};

const fr_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendu audio des événements (${i?.start}-${i?.end} sur ${i?.total})`)
};

const de_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio-Wiedergabe beim Ereignis (${i?.start}-${i?.end} von ${i?.total})`)
};

const it_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio dell'evento di rendering (${i?.start}-${i?.end} di ${i?.total})`)
};

const ru_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обработка аудиособытий (${i?.start}-${i?.end} из ${i?.total})`)
};

const es_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio del evento de renderizado (${i?.start}-${i?.end} de ${i?.total})`)
};

const zh_cn2_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`渲染事件音频（${i?.start}-${i?.end} 中的 ${i?.total}）`)
};

const ja_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベントオーディオのレンダリング (${i?.total} のうち ${i?.start}-${i?.end})`)
};

const hi_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ऑडियो रेंडरिंग (${i?.start}-${i?.end} of ${i?.total})`)
};

const pt_pt2_audio_description_export_status_rendering_batch = /** @type {(inputs: Audio_Description_Export_Status_Rendering_BatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renderizando áudio do evento (${i?.start}-${i?.end} de ${i?.total})`)
};

/**
* | output |
* | --- |
* | "Rendering Event Audio ({start}-{end} of {total})" |
*
* @param {Audio_Description_Export_Status_Rendering_BatchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_rendering_batch = /** @type {((inputs: Audio_Description_Export_Status_Rendering_BatchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Rendering_BatchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_rendering_batch(inputs)
	if (locale === "de") return de_audio_description_export_status_rendering_batch(inputs)
	if (locale === "it") return it_audio_description_export_status_rendering_batch(inputs)
	if (locale === "ru") return ru_audio_description_export_status_rendering_batch(inputs)
	if (locale === "es") return es_audio_description_export_status_rendering_batch(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_rendering_batch(inputs)
	if (locale === "ja") return ja_audio_description_export_status_rendering_batch(inputs)
	if (locale === "hi") return hi_audio_description_export_status_rendering_batch(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_rendering_batch(inputs)
	return en_audio_description_export_status_rendering_batch(inputs)
});